/**
 * Helper function that attempts defines web component only if it's not already been defined.
 * @param {string} tagName Name of the custom element. Example: 'g-button'.
 * @param {CustomElementConstructor} customElementConstructor Class definition for the custom element.
 * @param {ElementDefinitionOptions} options Options passed to customElements.define.
 */
export const defineCustomElement = (tagName, customElementConstructor, options) => {
	if (!window.customElements.get(tagName)) {
		window.customElements.define(tagName, customElementConstructor, options);
	}
};
